// import axios from 'axios';

// set of validators to be used with vuetifies' builtin validation of form/input elements

export default {
   data() {
      return {
      };
   },
   computed: {
   },

   methods: {
      // deprecated.
      isRequired(x, name='Value', disabled=false){
         if (!disabled){
            // let ans = (x  !==null && x !== undefined && ans !== '');
            let ans = !!x;

            if (x === false || x === 0){
               ans = true;
            }
            if (Array.isArray((x))){
               if (x.length === 0)
                  ans = false;
            }
            return ans || `${name} is required`;
         }
         else
            return true;

      },

      isRequired2(x, name='Value', {disabled=false, nullOk=false}){
         if (!disabled){
            // let ans = (x  !==null && x !== undefined && ans !== '');
            let ans = !!x;

            if (nullOk && x === null){
               ans = true;
            }

            if (x === false || x === 0){
               ans = true;
            }
            if (Array.isArray((x))){
               if (x.length === 0)
                  ans = false;
            }
            return ans || `${name} is required`;
         }
         else
            return true;

      },

      isNumber(x){
         let regx = /[+-]?[0-9]+(\.[0-9]+)?([Ee][+-]?[0-9]+)?/;
         return regx.test(x) || 'Must be a number';
      },
      checkEmail(x){
         //regex taken from https://emailregex.com/
         let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         return regx.test(x) || 'E-mail not valid';
      },

      checkRange(x, low, high, exceptions=[]){

         if (typeof x == 'string')
            x = Number(x);

         // console.log(x, exceptions)
         if (exceptions.includes(x)){
            return true;
         }



         return (x >= low && x <= high) || `Must be between ${low} and ${high}`
      },

      //validation for radio group
      checkRadioGroup(x){
         if (x === null || x === undefined)
            return 'Please select an answer';
         else
            return true;
      }

   }


};
